export const yandexMetrikaCounterId = 97389943
export const yandexMetrikaScriptId = 'cardreplay-yandex-metrika'

export type YandexMetrikaGoalParams = Record<string, boolean | number | string>

type YandexMetrika = {
  (...args: unknown[]): void
  a?: unknown[][]
  l?: number
}

declare global {
  interface Window {
    __cardReplayMetrikaInitialized?: boolean
    ym?: YandexMetrika
  }
}

export function initializeYandexMetrika() {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    window.__cardReplayMetrikaInitialized
  ) {
    return
  }

  if (!window.ym) {
    const queue: YandexMetrika = (...args: unknown[]) => {
      ;(queue.a ??= []).push(args)
    }
    queue.l = Date.now()
    window.ym = queue
  }

  if (!document.getElementById(yandexMetrikaScriptId)) {
    const script = document.createElement('script')
    script.id = yandexMetrikaScriptId
    script.async = true
    script.src = 'https://mc.yandex.ru/metrika/tag.js'
    document.head.append(script)
  }

  window.ym(yandexMetrikaCounterId, 'init', {
    accurateTrackBounce: true,
    clickmap: false,
    trackLinks: true,
    webvisor: false,
  })
  window.__cardReplayMetrikaInitialized = true
}

export function reachYandexMetrikaGoal(
  goal: string,
  params?: YandexMetrikaGoalParams,
) {
  if (typeof window === 'undefined') return
  window.ym?.(yandexMetrikaCounterId, 'reachGoal', goal, params)
}
